import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import BrowserStore from '../../browser/stores/BrowserStore';
import FuseBrowserModal from '../BrowserModal/FuseBrowserModal';
import BrowserModalCard from '../Fuse/BrowserModalCard';
import { FTBodySm } from '../Fuse';
import './BrowsingRestrictionsModal.css';

const block = b.lock('BrowsingRestrictionsModal');

/*
    reference: BrowserStore.NOTIFICATION.DEFAULT_RIGHT from RightNotifications.js
 */

const CARDS = (t, browser) => [
    {
        key: 'input_disabled',
        when: browser?.inputRestrictions === BrowserStore.INPUT_RESTRICTION.INPUT_DISABLED,
        title: t('Notification.browsingRestrictions.input_disabled.title'),
        icon: 'keyboard',
        text: t('Notification.browsingRestrictions.input_disabled.text'),
        iconColor: 'danger',
    },
    {
        key: 'paste_disabled',
        when: browser.inputRestrictions === BrowserStore.INPUT_RESTRICTION.PASTE_DISABLED,
        title: t('Notification.browsingRestrictions.paste_disabled.title'),
        icon: 'assignment',
        text: t('Notification.browsingRestrictions.paste_disabled.text'),
        iconColor: 'danger',
    },
    {
        key: 'paste_limited',
        when: browser.inputRestrictions === BrowserStore.INPUT_RESTRICTION.PASTE_TRUNCATED,
        title: t('Notification.browsingRestrictions.paste_limited.title'),
        icon: 'assignment',
        text: t('Notification.browsingRestrictions.paste_limited.text'),
        iconColor: 'danger',
    },
    {
        key: 'downloads_disabled',
        when: browser.isDownloadDisabled,
        title: t('Notification.browsingRestrictions.downloads_disabled.title'),
        icon: 'download_file',
        text: t('Notification.browsingRestrictions.downloads_disabled.text'),
        iconColor: 'danger',
    },
    {
        key: 'uploads_disabled',
        when: browser.isUploadDisabled,
        title: t('Notification.browsingRestrictions.uploads_disabled.title'),
        icon: 'upload_file',
        text: t('Notification.browsingRestrictions.uploads_disabled.text'),
        iconColor: 'danger',
    },
    {
        key: 'no_restrictions',
        when: false,
        title: t('Notification.browsingRestrictions.no_restrictions.title'),
        icon: 'web',
        text: t('Notification.browsingRestrictions.no_restrictions.text'),
        iconColor: 'default',
    },
];

class BrowsingRestrictionsModal extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
    };

    handleBack = () => {
        const { browser } = this.props;
        browser.browsingRestrictionsModal.close();
        browser.topBarMenu.open();
    };

    render() {
        const {
            t,
            browser
        } = this.props;

        // Determine which cards to show. If none of the restriction cards are active,
        // fall back to showing only the "no_restrictions" card.
        const cards = CARDS(t, browser);
        const visibleCards = cards.filter((c) => c.when);
        const cardsToShow = visibleCards.length > 0 ? visibleCards : cards.filter((c) => c.key === 'no_restrictions');

        return <FuseBrowserModal
            small
            hideFooter
            title={t('Notification.browsingRestrictions.title')}
            isOpen={browser.browsingRestrictionsModal.isOpen}
            onClose={() => browser.browsingRestrictionsModal.close()}
            onBack={this.handleBack}
        >
            {cardsToShow.map((c) => (
                <BrowserModalCard key={c.key} title={c.title} titleIcon={c.icon} iconColor={c.iconColor}>
                    <FTBodySm className={block('Text')}>{c.text}</FTBodySm>
                </BrowserModalCard>
            ))}
        </FuseBrowserModal>;
    }
}

export default translate()(inject('browser')(observer(BrowsingRestrictionsModal)));
